export default {
  general: {
    settings: "Configuración",
    show_time: "Mostrar visualización de hora",
    show_seconds: "Mostrar segundos",
    show_search: "Mostrar barra de búsqueda",
    show_wallpaper: "Mostrar botón de cambio de fondo",
    show_bookmark: "Mostrar botón de marcadores",
    show_weather: "Mostrar clima",
    show_top_sites: "Mostrar sitios visitados con frecuencia",
    auto_change_background: "Cambiar el fondo automáticamente",
    auto_change_every: "Cambiar cada",
    days: "días",
    hours: "horas",
    minutes: "minutos",
    interval_required: "Los días, las horas y los minutos no pueden ser todos 0",
    sync_enabled: "Sincronización en la nube de tareas",
    show_ai_chat: "Mostrar botón de chat con IA",
  },
  profile: {
    title: "Perfil",
    logout: "Cerrar sesión",
    sign_in: "Iniciar sesión",
    sign_in_desc: "Por favor, inicia sesión para desbloquear la experiencia completa",
    avatar_updated: "Avatar actualizado con éxito",
    nickname_updated: "Apodo actualizado con éxito",
    avatar_size: "El tamaño del archivo del avatar no debe exceder los 500KB",
    login_required: "Debes iniciar sesión para actualizar tu avatar",
    login_success: "Inicio de sesión exitoso",
    user_avatar: "Avatar de usuario",
    edit_avatar: "Editar avatar",
    save: "Guardar",
    cancel: "Cancelar"
  },
  subscription: {
    title: "Suscripción",
    check: "Verificar mi suscripción",
    upgrade: "Mejorar suscripción",
    subscribe: "Suscribirse a Tabby",
    expired_on: "Expiró el: {0}",
    expires_on: "Expira el: {0}",
    plans: {
      premium: "Desbloquea todo en Tabby: fondos de pantalla ilimitados, fondos personalizados y colecciones exclusivas.",
      pro: "Mejora tu suscripción para desbloquear fondos de pantalla ilimitados, fondos personalizados y colecciones exclusivas.",
      free: "Suscríbete para desbloquear fondos de pantalla ilimitados, fondos personalizados y colecciones exclusivas."
    }
  },
  wallpaper: {
    title: "Fondo de pantalla",
    upload: "Subir fondo personalizado",
    upgrade_required: "Actualiza al plan Pro/Premium para desbloquear la función de fondo personalizado",
    images: "Imágenes",
    hues: "Tonos",
    anims: "Animaciones",
    diy: "Personalizado",
    get_new: "Obtener nuevo",
    upload_background: "Subir fondo",
    add: "Añadir",
    remote_url: "URL de imagen remota",
    size_tip: "Los archivos de fondo más pequeños cargan las pestañas más rápido. La mayoría de los navegadores tienen un límite de tamaño de archivo de 1,5 MB. Las URL remotas no tienen restricciones.",
    please_login: "Por favor, inicia sesión primero",
    click_to_upload: "Haz clic para subir",
    video_gif_image: "video, GIF o imagen",
    background: "fondo",
    or_enter_remote_background_url: "O ingresa URL de fondo remoto",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "Fondo personalizado eliminado",
    failed_to_load_background: "Error al cargar el fondo",
    using_default: "Usando fondo predeterminado en su lugar",
    insufficient_storage: "Almacenamiento insuficiente",
    upload_failed: "Fallo en la subida",
    success: "Éxito",
    remote_background_added: "Fondo remoto añadido",
    detecting_media_type: "Detectando tipo de medio...",
    invalid_media_type: "Tipo de medio no reconocido",
    video_load_failed: "El video no puede cargarse, por favor verifica si la URL es correcta"
  },
  rewards: {
    title: "Recompensas",
    invite_friends: "Invitar amigos",
    get_access: "Invita a amigos y desbloquea descuentos en Pro",
    total_invites: "Invitaciones totales",
    your_discount: "Tu descuento",
    no_pro_yet: "Ninguno todavía",
    copy_link: "Copiar enlace de invitación",
    copied: "¡Enlace de invitación copiado!",
    copy_failed: "Error al copiar enlace",
    invite_description: "Un amigo se registra con tu enlace",
    receive_credits: "Tú obtienes: 1 invitación → 5% dto., 2 → 8% dto., 3 → 15% dto., 4+ → 20% dto. · Cada amigo obtiene 5% de descuento"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "PRO ACTIVO",
    expires: "expira",
    free_plan: "PLAN GRATUITO",
    tagline: "Desbloquea cuotas de chat completas, sincronización de tareas en la nube y todas las funciones de fondos de pantalla en esta extensión.",
    monthly: "MENSUAL",
    yearly: "ANUAL",
    month_period: "/mes",
    year_period: "/año",
    billed_monthly: "Facturación mensual · cancela cuando quieras",
    billed_yearly: "Facturación anual",
    checkout_usd: "Pago",
    save_yearly: "Ahorra 17% frente a mensual",
    best_value: "MEJOR VALOR",
    referral_price: "Precio por invitación",
    save: "ahorra",
    subscribe_now: "Suscribirse ahora",
    current_plan: "Plan actual",
    processing: "Procesando",
    waiting_title: "Esperando el pago",
    waiting_desc: "Completa el pago en la ventana recién abierta.",
    payment_completed: "Pago completado",
    having_issues: "Tengo problemas",
    invite_save: "Invita amigos y ahorra en Pro",
    sign_in_first: "Inicia sesión primero",
    checkout_failed: "No se pudo crear la sesión de pago",
    payment_failed: "Pago fallido",
    payment_wrong: "Algo salió mal. Por favor, inténtalo de nuevo.",
    success_msg: "¡Felicitaciones! Pago completado con éxito",
    not_paid_msg: "El pago aún no se ha completado. Completa el pago en la ventana o inténtalo de nuevo.",
    verify_failed: "No se pudo verificar el estado del pago. Inténtalo de nuevo o contacta al soporte.",
    contact_email: "Contacta por correo: hi@tabbyio.com"
  },
  about: {
    title: "Acerca de",
    version: "Versión: 1.3.11",
    contact: "Contáctanos:",
    privacy_policy: "Política de Privacidad",
    terms_of_service: "Términos de Servicio"
  },
  tabs: {
    general: "Preferencias",
    profile: "Perfil",
    wallpaper: "Fondo",
    rewards: "Recompensas",
    about: "Acerca de"
  },
  language: {
    title: "Idioma",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "Marcadores",
    next_background: "Siguiente fondo",
    ai_chat: "Chat con IA",
    search_placeholder: "Busca o presiona Ctrl + Enter para chat con IA...",
    attach: "Adjuntar archivo",
  },
  greetings: {
    morning: "Buenos días",
    afternoon: "Buenas tardes",
    evening: "Buenas noches",
    morning_message: "Un nuevo día comienza, ¿cómo puedo ayudarte?",
    afternoon_message: "Hora de la tarde, ¿tienes alguna pregunta que hacer?",
    evening_message: "Hora de la noche, ¡déjame charlar contigo!"
  },
  intro: {
    your_portal: "Tu portal",
    for: "para",
    productivity: "productividad.",
    inspiration: "inspiración.",
    photography: "fotografía.",
    description: "Donde cada nueva pestaña se convierte en una puerta",
    description_continued: "hacia la elegancia, la productividad y más allá.",
    add_to_chrome: "Añadir a Chrome",
    free: "Gratis",
    try_now: "Probar ahora",
    screenshot: "Captura de pantalla"
  }
}

